import React from 'react'
import Logoar from "./pics/logo.jpeg";
import Share from "../../components/share.js";
import "./jawaan.css" 
import img from "./pics/firstsight.png";
const OMG2 = () => { 
  return  (
 
    <div className="shortstory-container">
        <img src={Logoar} alt="Logoar" className="logoarr" />
      <div className="blue-bg">
     
      
        
        <header class="entry-header">
		<h4 class="entry-meta"><a href="https://nooffensebut.vercel.app/MovieReviews" target='_blank' data-wpel-link="internal">Movie and Show Reviews</a></h4>
		<h1 class="entry-title">Love at First Sight</h1>
		<div class="entry-meta">
			<span class="byline">by <span class="author vcard"><a class="url fn n" href="https://nooffensebut.vercel.app/aboutus" target='_blank' data-wpel-link="internal">Shreya</a></span></span><span class="meta-divider"> | </span><span class="posted-on"><a href="https://nooffensebut.vercel.app/content" target='_blank' rel="bookmark" data-wpel-link="internal"><time class="entry-date published" datetime="2018-03-01T07:27:10-05:00">12.10.2023</time><time class="updated" datetime="2018-03-01T11:10:42-05:00"></time></a><span>		</span></span></div>
	</header>
       
 
  <img src={img} alt="Logoar" className="moo" />

        <div className="description1-2">
            <div className="rate">Rating: 4</div> <div className="genre">Genre:Romance,Comedy</div>
            <p>‘Love at first sight’ is a refreshing breath of air in the age-old genre of rom-com. While even the name of the movie is very cliche, the movie itself manages to surprise you and portray love in a new way.</p>
<br/>
<p>The characters of the movie are nothing unique. Hadley is a clumsy 20-something-year-old who is always late to everything and struggles to get her life together. Oliver is a logical 20-something-year-old who shines when it comes to mathematics but not so much when it comes to talking about his feelings. But, their encounter at the airport is what gives the movie its edge. Hadley and Oliver hit it off after just one conversation, and their chemistry flows smoothly on screen.</p>
<br/>
<p>Though the entire plot happens in just 2 days, I loved how nothing seemed rushed or forced. There are enough meaningful conversations between Hadley and Oliver for them to have fallen in love with each other in just 8 hours. Despite knowing each other for such a short time, they manage to understand and solve each other’s problems.</p>
<br/>
<p>I also loved Oliver’s family, especially his dynamic with his mom. Oliver goes through major character development in the movie as he learns to grab the moment and articulate his feelings before it’s too late. Hadley too understands the importance of letting go and forgiving people you love to maintain good relations.</p>
<br/>
<p>Overall, the movie covers all aspects of adolescence, while also telling a sweet love story. ‘Love at first sight’ is a great movie for a young audience who are going through the same phases as Hadley and Oliver.</p>
          <br/>


    <hr></hr>
</div>



          <Share/>
      </div>
</div> )}

export default  OMG2;

 


